module.exports = __webpack_public_path__ + "img/3.ddd0c560.png";